// Registers the step types with the registry.
import { registerSteps } from "../registry";
import { codeStep } from "./code";

registerSteps([codeStep]);
